import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';
import { ParticipationTranslationKeys } from '../../EmployeeIncomeParticipations.types';

export const ParticipationsEmpty: React.FC = () => {
  return (
    <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant="body2">
        <FormattedMessage id={ParticipationTranslationKeys.noParticipations} />
      </Typography>
    </Box>
  );
};
